import { Icon, VisuallyHidden } from '@mage-ui/components';
import { cx } from '@mage-ui/styled-system/css';
import { shopCardPlaceholder } from '@mage-ui/styled-system/recipes';

export const ShopCardPlaceholder = ({ className, texts }) => {
	return (
		<span className={cx(shopCardPlaceholder().root, className)}>
			<VisuallyHidden>{texts.a11yText}</VisuallyHidden>
			<Icon
				name='ticket'
				className={shopCardPlaceholder().icon}
				aria-hidden='true'
			/>
		</span>
	);
};
